import ChangePassword from './components/ChangePassword';
import LoginHOC from '../../../../components/LoginHOC';

export default (store) => ({
  path: 'reset-password',
  component: LoginHOC(ChangePassword),
});



// WEBPACK FOOTER //
// ./src/routes/user/routes/ChangePassword/index.js